export const environment = {
  production: false,
  name: 'qa',
  enUrl: 'https://bmo-smartapp-user-guide-qa.paralucent-apps.com',
  frUrl: null as string | null,
  frHostname: null as string | null,
  googleAnalyticsId: 'G-VT4PBSMLZV', // TODO: add QA measurement ID (e.g. 'G-XXXXXXXXXX')
};
